import { useModalStore } from '../..'
import type { FullStore } from '../types'
import type { GlobalModal } from './types'

const useModals = () => useModalStore((state) => (state as FullStore).modals)

const useOpenModals = () =>
    useModalStore((state) => (state as FullStore).modals.filter((modal: GlobalModal) => modal.open))

const useTopModal = () =>
    useModalStore((state) => {
        const modals = (state as FullStore).modals

        if (modals.length === 0) {
            return null
        }

        return modals[modals.length - 1]
    })

export const modalSelectors = {
    useModals,
    useOpenModals,
    useTopModal,
}
